module.exports = __webpack_public_path__ + "img/dizhitianchong-@2x.ff2f80ed.png";